import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const UAIconsNotificationBell = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon {...rest} viewBox="0 0 25 25">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4955 18.3541C19.5425 18.3541 20.3922 17.5071 20.3955 16.4601V16.4601V16.4601C20.3949 15.9274 20.1822 15.4168 19.8045 15.0411L18.5455 13.7811V10.0381C18.5453 8.5669 17.9602 7.15611 16.9192 6.11645C15.8783 5.07679 14.4667 4.49353 12.9955 4.49512V4.49512C9.93521 4.49678 7.45507 6.97782 7.45452 10.0381V13.7781L6.19552 15.0381C5.81755 15.4137 5.60455 15.9243 5.60352 16.4571V16.4571V16.4571C5.60682 17.5041 6.45651 18.3511 7.50352 18.3511L18.4955 18.3541Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 20.5002H14"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

UAIconsNotificationBell.propTypes = {
  color: PropTypes.string
};

UAIconsNotificationBell.defaultProps = {
  color: 'var(--color-i-icon-base-fill)'
};

export default UAIconsNotificationBell;
